import { useState } from "react";
import {
  GetMeetingNewPageQueryQuery,
  MeetingViewMeetingNodeNewPageFragmentFragment,
} from "types/graphql-schema";

import MeetingDropdownMenu from "@apps/meeting-dropdown-menu/meeting-dropdown-menu";
import MeetingContentAccessDropdown from "@apps/meeting-settings/components/content-access-dropdown";
import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import AppPopover from "@components/popover/app-popover";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

import MeetingBot from "./meeting-bot";
import ShareNotesDialog from "./share-meeting/share-meeting-notes-dialog";

const MeetingPageHeader = ({
  meetingGroup,
  meeting,
}: {
  meetingGroup: NonNullable<
    NonNullable<GetMeetingNewPageQueryQuery["meeting"]>["meetingGroup"]
  >;
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
}) => {
  const [isShowingShareNotesDialog, setIsShowingShareNotesDialog] =
    useState(false);

  const handleShareNotesDialog = () => {
    setIsShowingShareNotesDialog(true);
  };

  const handleCloseInvitationDialog = () => {
    setIsShowingShareNotesDialog(false);
  };

  return (
    <>
      <MeetingContentAccessDropdown meetingGroup={meetingGroup}>
        <AppPopover.Button
          as={Button}
          theme={buttonTheme.text}
          size={ButtonSize.medium}
          aria-label="Meeting header permission dropdown menu button"
          disabled={!meetingGroup?.canUpdate?.permission}
          className="px-0 w-[24px] shrink-0"
        >
          {!meetingGroup.allowAdminVisibility &&
          !meetingGroup.allowOrgVisibility &&
          !meetingGroup.allowManagementTreeVisibility ? (
            <TopicflowIcon
              type="lockClosed"
              className="h-4 w-4 text-gray-400 shrink-0"
            />
          ) : (
            <TopicflowIcon
              type="lock"
              className="h-4 w-4 text-gray-400 shrink-0"
            />
          )}
        </AppPopover.Button>
      </MeetingContentAccessDropdown>

      <MeetingBot
        meeting={meeting}
        textClassName="hidden"
        buttonProps={{ size: ButtonSize.medium }}
      />

      <MeetingDropdownMenu
        meeting={meeting}
        meetingGroup={meetingGroup}
        size="5"
        onOpenSendNotesDialog={handleShareNotesDialog}
        buttonProps={{ size: ButtonSize.medium }}
      />

      {isShowingShareNotesDialog && (
        <ShareNotesDialog
          meeting={meeting}
          onClose={handleCloseInvitationDialog}
          isInviteDialog={false}
        />
      )}
    </>
  );
};

export default MeetingPageHeader;
